import cx from 'classnames';
import PropTypes from 'prop-types';

import { getLanguageChipLabel } from 'src/data/generation';

import { CustomChip } from '../CustomChip';

import { useStyles } from './useStyles';

export const BrandVoiceLanguageTag = ({ className, brandVoiceLanguage, disabled }) => {
  const styles = useStyles();

  if (!brandVoiceLanguage) {
    return null;
  }

  return (
    <CustomChip
      className={cx(styles.root, className, { [styles.disabled]: disabled })}
      label={getLanguageChipLabel(brandVoiceLanguage)}
      disabled={disabled}
    />
  );
};

BrandVoiceLanguageTag.propTypes = {
  brandVoiceLanguage: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

BrandVoiceLanguageTag.defaultProps = {
  brandVoiceLanguage: null,
  className: '',
  disabled: false,
};
